import { Component, Input, OnInit } from '@angular/core';
import { Router } from '@angular/router';

@Component({
  selector: 'app-link-card',
  templateUrl: './link-card.component.html',
  styleUrls: ['./link-card.component.scss']
})
export class LinkCardComponent implements OnInit {

  @Input() LinkCardArr: any;
  constructor(private router: Router) { }
  ngOnInit(): void {
  }
  linkCardClicked(data: any) {
    if (data.Title_Name.toLowerCase() == "faq") {
      this.router.navigate([data.Title_Name.toLowerCase()]);
    } else {
      window.open(data.Link, "_blank");
    }

  }
}
